/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconRules/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconRules({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconRules",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 20,
  height = 20,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#3E87CA"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconRules.Svg"
  data-view-path={viewPath}
 viewBox="0 0 20 20"
 style={{'--as-1-n0JGW': alignSelf,'--mt-2-n0JGW': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-n0JGW': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-n0JGW': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-n0JGW': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-n0JGW': opacity,'--w-10-n0JGW': typeof width === 'number' ? `${width}px` : width,'--h-11-n0JGW': typeof height === 'number' ? `${height}px` : height,'--f-12-n0JGW': fill,'--a-7-n0JGW': isAnimated ? animation : "none",'--sd-8-n0JGW': isAnimated ? strokeDashoffset : 0,'--sd-9-n0JGW': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconRules.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M4.5 3A1.5 1.5 0 003 4.5v11A1.5 1.5 0 004.5 17h11a1.5 1.5 0 001.5-1.5v-11A1.5 1.5 0 0015.5 3h-11zm10 4.5a1.75 1.75 0 01-3.385.625H6a.625.625 0 110-1.25h5.115A1.75 1.75 0 0114.5 7.5zm-.5 4.375h-3.115a1.75 1.75 0 00-3.27 0H6a.625.625 0 100 1.25h1.615a1.75 1.75 0 003.27 0H14a.625.625 0 100-1.25z"
 style={{'--f-12-n0JGW': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}